import { atom } from "recoil";

export const fnolPageDeciderState = atom({
  key: "fnolPageDeciderState",
  default: {
    stage: 1,
  },
});
